import { useState, useCallback } from 'react';

export type Mode = 'browse' | 'add' | 'edit';

export function useC208Mode() {
  const [mode, setMode] = useState<Mode>('browse');
  const isEditing = mode === 'add' || mode === 'edit';
  const startEdit = useCallback(() => setMode('edit'), []);
  const startAdd = useCallback(() => setMode('add'), []);
  const stopEdit = useCallback(() => setMode('browse'), []);
  return { mode, setMode, isEditing, startEdit, startAdd, stopEdit };
}
